export default {
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://r6jjaxw9re.execute-api.eu-west-2.amazonaws.com/prod"
  },
  cognito: {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_CrKtEXFeZ",
    APP_CLIENT_ID: "1shdhodbq5qsnu490rb7tnvn6l",
    IDENTITY_POOL_ID: "eu-west-2:559415f1-2b97-45cd-95d7-ec5abee5c2ad"
  }
};



// WEBPACK FOOTER //
// ./src/config.js